// --------------------------------------------------------------------------
// googleMap.js
// --------------------------------------------------------------------------
// Initialises different map modules depending on what blocks are on the page
// --------------------------------------------------------------------------

EC.googleMap = function () {

    'use strict';

    function init () {
        const parkingMap = document.getElementById('js-parking-map');
        if(parkingMap){
            EC.parkingMap.init();
        }

        const gettingHereMap = document.getElementById('js-getting-here-map');
        if(gettingHereMap){
            EC.gettingHereMap.init();
        }

        const propertyMap = document.getElementById('js-property-map');
        if(propertyMap){
            EC.propertyMap.init();
        }
    }

    return {
        init: init
    };

}();